import React, { useRef, useEffect } from "react";
import spinnerIcon from "../../../../../content/icons/ee_spinner.gif";
import echoImage from "../../../../../content/icons/echoImage.png";

export default function OrganizationPrompt({
  selectedOrganization,
  setSelectedOrganization,
  index,
  chatItems,
  isThinking,
  handleCitationClick,
}) {
  const handleChange = (event) => {
    setSelectedOrganization({ selected: event.target.value }, index);
  };

  const chatItemsEndRef = useRef(null);

  const scrollToBottom = () => {
    chatItemsEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [chatItems, isThinking]);

  return (
    <div className="organization-prompt">
      {/* <select
        name="organizations"
        id="organizations-select"
        onChange={handleChange}
        value={selectedOrganization?.selected ?? ""}
        className="organization-prompt-select"
      >
        <option value="">Choose an Organizational Guardrail </option>
        <option value="arizona-tap">Arizona Tap</option>
        <option value="louisiana-tap">Louisiana Tap</option>
        <option value="texas-tap">Texas Tap</option>
      </select> */}
      <div className="organization-prompt-answer">
        {chatItems?.map((item, index) => (
          <div key={index} className="organization-prompt-answer-item">
            <div className="chat-panel-content-inner-question background-set">
              <img
                src={echoImage}
                alt="Thinking..."
                style={{ marginRight: "8px", height: "36px" }}
              />
              <p>{item.question}</p>
            </div>
            <div
              className="answerText"
              dangerouslySetInnerHTML={{
                __html: item.answerHtml,
              }}
              onClick={handleCitationClick}
            />
          </div>
        ))}
        {/* {selectedOrganization?.value && (
          <div
            className="answerText"
            dangerouslySetInnerHTML={{
              __html: selectedOrganization?.value?.answerHtml,
            }}
          />
        )} */}
        {isThinking === true && (
          <div className="chat-panel-content-inner-question">
            <img
              src={spinnerIcon}
              alt="Thinking..."
              className="thinking-spinner"
            />
            <p>Thinking...</p>
          </div>
        )}
        <div ref={chatItemsEndRef} />
      </div>
    </div>
  );
}
